import { CompanyDocumentReadConfirmationConfirmDate } from "./confirm-date/company-document-read-confirmation-confirm-date";
import { CompanyDocumentReadConfirmationSignedFileName } from "./signed-file-name/company-document-read-confirmation-signed-file-name";

/**
 * Ознакомление участника с документом компании: показ поля решается один раз здесь,
 * а не в таблице аналитики и карточке участника по отдельности. Подкомпонент
 * принимает запись целиком — `<CompanyDocumentReadConfirmation.ConfirmDate data={record} />`.
 */
export const CompanyDocumentReadConfirmation = {
  ConfirmDate: CompanyDocumentReadConfirmationConfirmDate,
  SignedFileName: CompanyDocumentReadConfirmationSignedFileName,
};
